import { OrderRequest } from "../../api";

// eslint-disable-next-line import/prefer-default-export
export const hasChanges = (one: OrderRequest, two: OrderRequest) =>
  JSON.stringify(one) !== JSON.stringify(two);
